import { hide, show, toggle } from "slidetoggle";
import { Breakpoints } from "../../breakpoints";

const slideToggleDefaults = {
  miliseconds: 200,
};
const slideToggle = (el, opts = {}) => {
  toggle(el, { ...slideToggleDefaults, ...opts });
};
const slideUp = (el, opts = {}) => {
  hide(el, { ...slideToggleDefaults, ...opts });
};
const slideDown = (el, opts = {}) => {
  show(el, { ...slideToggleDefaults, ...opts });
};
const isHidden = (el) => el.offsetParent === null;

export const SlideToggleBinders = {
  accordionTrigger: "accordionToggleNext",
  slideTrigger: "slideToggleNext",
};

export const SlideToggleNext = () => ({
  "@click"(e) {
    e.preventDefault();
    e.stopPropagation();

    this.open = !this.open;
  },
  "x-data": () => ({
    open: false,
  }),
  "x-init"() {
    this.$watch('open', (openValue) => {
      if (openValue) slideDown(this.$el.nextElementSibling);
      else slideUp(this.$el.nextElementSibling);
    });
    this.open = !isHidden(this.$el.nextElementSibling);
  }
});

export const AccordionToggleNext = () => ({
  ...SlideToggleNext(),
  "@click"(e) {
    e.preventDefault();
    e.stopPropagation();

    this.open = !this.open;

    const otherAccordions = this.$el.closest("nav, .box")?.querySelectorAll(`[x-bind="${SlideToggleBinders.accordionTrigger}"]`);

    otherAccordions?.forEach((accordion) => {
      if (accordion == this.$el) return;
      accordion.dispatchEvent(new CustomEvent("closeElement"));
    })
  },
  "@closeElement"(e) {
    this.open = false;
  },
  "x-init"() {
    this.$watch('open', (openValue) => {
      if (openValue) slideDown(this.$el.nextElementSibling);
      else slideUp(this.$el.nextElementSibling);
    });
    this.open = !isHidden(this.$el.nextElementSibling) || this.$el.parentNode.classList.contains('menu__item--active-trail');

    if (this.$el.closest('.site-footer__footer-bottom')) {
      this.openWas = this.open;
      addEventListener('resize-event:max-lg', () => {
        this.open = false;
      });
      addEventListener('resize-event:min-lg', () => {
        this.open = true;
      });
      // let sizeWas = window.innerWidth;
      // addEventListener("resize", (e) => {

      //   if (sizeWas <= Breakpoints.lg && window.innerWidth > Breakpoints.lg) {
      //     console.log()
      //   }
      //   sizeWas = window.innerWidth;
      // });
    }
  },
});
